<template>
  <div class="c-list-image">
    <a :href="url">
      <img v-bind="getImage()" />
    </a>
  </div>
</template>

<script>
import config from '../../../temp/config';

export default {
  name: 'CIS-Resource-PagedListing-Image',
  props: {
    image: {
      type: Object,
      default: () => ({})
    },
    alt: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    },
    template: {
      type: String,
      default: () => ''
    },
    topics: {
      type: String,
      default: () => ''
    },
    topicImageSrc: {
      type: Function,
      default: () => undefined
    }
  },
  methods: {
    getImage() {
      const imageAlt = (value) => {
        return this.alt || this.image.alt || value;
      };

      if (this.image?.src?.length > 0) {
        return {
          src: this.image.src,
          alt: imageAlt('CIS')
        };
      } else if (this.template === 'CIS-Resource-Benchmark-RouteType') {
        return {
          src: `${config.sitecoreApiHost}/-/media/Project/cisecurity/cisecurity/data/media/img/thumbnail-cis-benchmarks.png`,
          alt: imageAlt('CIS Benchmarks')
        };
      } else if (this.template !== 'CIS-Resource-Advisory-RouteType' && this.topicImageSrc) {
        return { ...this.topicImageSrc(this.topics), alt: imageAlt('CIS') };
      } else {
        return {
          src: `${config.sitecoreApiHost}/-/media/Project/cisecurity/cisecurity/data/media/img/thumbnail-cis.png`,
          alt: imageAlt('CIS')
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-list-image {
  width: 28%;
  flex-shrink: 0;
  height: auto;
  margin-right: 1.5rem;

  @include desktop-up {
    margin-right: 5rem;
  }

  img {
    width: 100%;
    height: auto;
  }

  &:deep() {
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
